module.exports = __webpack_public_path__ + "static/media/chevron-right.e7ca65aa.svg";